import ShortlistAspirantContainer from './ShortlistAspirantContainer';

export default ShortlistAspirantContainer